module.exports = __webpack_public_path__ + "img/netopia_banner_gradient.0c573116.jpg";